import { AxiosError } from "axios";
import { useMutation, useQueryClient } from "react-query";
import { api } from "services/api";
import { handleRequestError, handleRequestSuccess } from "utils/Request";

type Payload = { id: string; tme?: string; tma?: string };

async function updateAttendanceTimes({ id, ...data }: Payload) {
  return api.put(`/support/closed-attendances/${id}`, data);
}

export function useUpdateAttendanceTimes() {
  const queryClient = useQueryClient();

  return useMutation((payload: Payload) => updateAttendanceTimes(payload), {
    onSuccess: () => {
      handleRequestSuccess('TME/TMA atualizados!');
      queryClient.invalidateQueries('closed-attendances');
    },
    onError: (error: AxiosError) => {
      handleRequestError(error, 'Erro ao atualizar TME/TMA. Tente novamente.');
    },
  });
}
